	export enum EventLogEntryType {
		Error = 1,
		Warning = 2,
		Information = 4,
		SuccessAudit = 8,
		FailureAudit = 16
	}



// WEBPACK FOOTER //
// ./typings/board/Diagnostics.ts